var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHikmah(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 28",
    width: 33,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hikmah") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #01a48e } \n\t\t.s1 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m16.1 15.3q-0.8 0.1-1.7 0.2c-0.5 0-1-0.5-0.8-1.1 0 0 2.8-11.7-3.2-13.2-3.5-0.9-7.7 2.9-9.6 10-0.1 0.1-2.1 7.9 0.7 12.3 0.8 1.4 2.3 2.4 4.2 2.6q0.6 0 1.2-0.1 0 0.1 0 0.1c5.6-0.8 8.7-8 9.6-10.3 0.1-0.3-0.1-0.6-0.4-0.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m17 12.7q0.8-0.1 1.6-0.2c0.6 0 1 0.5 0.8 1.1 0 0-2.8 11.7 3.2 13.2 3.6 0.9 7.7-2.9 9.7-10 0-0.1 2.1-7.9-0.7-12.3-0.9-1.4-2.4-2.4-4.3-2.6-0.4 0-0.6 0-0.8 0 0 0-0.4 0-0.4 0-5.6 0.8-8.7 8-9.6 10.3-0.1 0.3 0.1 0.6 0.5 0.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m59.3 10v13h3.9v-9.2c0-2.1-1.8-3.8-3.9-3.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m63.2 5h-3.9v3.5h3.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m99.4 8.7c-1.8 0-3.4 0.9-4.4 2.2-0.8-1.4-2.3-2.2-4.2-2.2-1.7 0-3.2 0.8-4.2 2.1 0-1.2-1-2.1-2.2-2.1h-1.3v14.3h3.9v-7.6c0-2.1 1-3.4 2.8-3.4 1.4 0 2.1 1 2.1 2.9v8.1h3.8v-7.6c0-2.1 1-3.4 2.8-3.4 1.4 0 2.1 1 2.1 2.9v8.1h3.9v-8.8c0-3.2-2.1-5.5-5.1-5.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m119.2 8.6v1.7c-1.3-1.2-3.2-1.8-5.3-1.6-3.7 0.3-6.7 3.5-6.6 7.2 0 4 3.2 7.1 7.3 7.1 1.8 0 3.3-0.6 4.5-1.7v1.7h3.3v-11.2c0-1.8-1.4-3.1-3.2-3.1zm-4.3 10.8c-2.2 0-3.8-1.6-3.8-3.7 0-2.1 1.6-3.7 3.8-3.7 2.2 0 3.8 1.6 3.8 3.7 0 2.1-1.6 3.7-3.8 3.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m78.6 15c1-1.1 1.5-2.6 1.5-4.1v-2.2h-4v2.3c0 0.5-0.1 1.1-0.5 1.5-0.4 0.5-1.1 0.8-1.8 0.8h-2.7v-4.5c0-2.1-1.7-3.8-3.9-3.8v18h3.9v-8.2l5.5 8.2h4.7l-4.4-6.6q1-0.5 1.7-1.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m132.8 8.7c-1.1 0-2.2 0.3-3.1 0.7v-0.5c0-2.1-1.8-3.9-4.1-3.9v10.7q0.1 0 0 0v7.3h4.1v-7.3c0-1.7 1.4-3.1 3.1-3.1 1.8 0 3.2 1.4 3.2 3.1v7.3h4v-7.3c0-3.9-3.2-7-7.2-7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m51.4 5v4.5c0 1.1 0.5 2.2 1.4 2.9h-7.7v-3.5c0-2.1-1.8-3.9-4-3.9v17.9h4v-4.8c0-1.1-0.5-2.2-1.4-3h1.4 6.3v7.8h4v-14c0-2.1-1.8-3.9-4-3.9z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHikmah);
export default __webpack_public_path__ + "static/media/hikmah.309df9e7cb744cba98710d23880fb8f4.svg";
export { ForwardRef as ReactComponent };